import React, { FC, useRef, useState } from 'react';
import { appStore } from '@store';
import {
	Benefits,
	GetMyPlanBlock,
	Reviews,
	Footer,
	Header,
	BeforeAfter,
	MainScreen,
	Plan,
	Guarantee,
	Discount,
} from './components';
import { useT } from '@hooks';
import * as S from './styled';

interface Props {
	children: React.ReactElement;
}

export const PaywallLayoutPilates: FC<Props> = props => {
	const { children } = props;
	const { answers } = appStore.surveyStore;
	const { paymentStore } = appStore;
	const { T } = useT();
	const goalWeight = answers.target_weight?.[0]
		? Number(JSON.parse(answers.target_weight?.[0]).value)
		: 0;
	const currentWeight = answers.weight?.[0] ? Number(JSON.parse(answers.weight?.[0]).value) : 0;
	const childrenRef = useRef<HTMLDivElement>(null);
	const [showTimer, setShowTimer] = useState(true);

	const scrollToChildren = () => {
		const scrollContainer = document.querySelector('#root');
		if (childrenRef.current) {
			const offset = 72;
			const elementPosition = childrenRef.current.getBoundingClientRect().top;
			const offsetPosition = elementPosition - offset;

			if (scrollContainer) {
				scrollContainer.scrollBy({
					top: offsetPosition,
					behavior: 'smooth',
				});
			}
		}
	};

	return (
		<S.Container>
			{showTimer && <Header setShowTimer={setShowTimer} onButtonClick={scrollToChildren} />}
			<S.Padding20 showTimer={showTimer}>
				{paymentStore.isShowTimer && <Discount />}
				<MainScreen />
				<S.MarginTop32>
					<Plan />
				</S.MarginTop32>
				<div ref={childrenRef}>{children}</div>
				<GetMyPlanBlock />
				<S.MarginTop32>
					<Benefits />
				</S.MarginTop32>
				<S.MarginTop32>
					<BeforeAfter />
				</S.MarginTop32>
				<S.MarginTop32>
					<Reviews />
				</S.MarginTop32>
				<S.MarginTop32>
					<Plan />
				</S.MarginTop32>
				{children}
				<GetMyPlanBlock />
				<S.MarginTop32>
					<Guarantee />
				</S.MarginTop32>
			</S.Padding20>
			<Footer />
		</S.Container>
	);
};
